import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntExpContributedService {

  constructor(private http: HttpClient) { }

  /**
   * Generic method to get JSON object from backend
   */
  getJsonObject(
    baseUrl: string,
    params: any,
    globalService: any = {},
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Merge parameters with global service and filter params - EXACTLY like AngularJS
    const paramsMerge = Object.assign({}, filterParams, params);
    const requestParams = Object.assign({}, globalService, paramsMerge);
    
    // Delete checkLockedbj like AngularJS does
    delete requestParams.checkLockedbj;

    // CRITICAL: Use GET with query parameters like AngularJS JsonObjectFactory
    return this.http.get<any>(url, { 
      params: requestParams, 
      withCredentials: true 
    });
  }

  /**
   * Save Interest Expense Contributed adjustment
   * CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
   */
  saveIntExpContributed(
    baseUrl: string,
    returnObj: any,
    transactionDetails: any[],
    otherInfo: any,
    lockObj: any[],
    globalService: any = {},
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=zlxjsx`;

    // Merge parameters with global service and filter params - EXACTLY like AngularJS
    let params = Object.assign({}, globalService, filterParams);

    // Prepare data according to AngularJS structure
    const jsonObj = JSON.stringify(transactionDetails);
    const clobSettings = JSON.stringify({
      sso_id: otherInfo.sso_id,
      tax_year: otherInfo.tax_year?.toString(),
      scenario: otherInfo.scenario?.toString(),
      jcd_key: otherInfo.jcd_key?.toString()
    });

    // Add required parameters
    params.clob_data = jsonObj;
    params.clob_settings = clobSettings;
    params.sso_id = otherInfo.sso_id;
    params.tax_year = otherInfo.tax_year;
    params.scenario = otherInfo.scenario;
    params.jcd_key = otherInfo.jcd_key;
    params.screen_key = otherInfo.SCREEN_KEY;
    params.process_name = "INT_EXPSAVE";

    // CRITICAL: Add scenarioCode and is_issue_key_enabled
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || globalService?.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";

    // CRITICAL: Add checkLockedbj from rowData or lockObj (for CREATE mode)
    if (lockObj && lockObj.length > 0) {
      // CREATE mode: Use lockObj to build checkLockedbj
      const checkLockedbj = lockObj.map(item => ({
        combination_key: item.combination_key
      }));
      params.checkLockedbj = JSON.stringify(checkLockedbj);
    } else if (rowData && Object.keys(rowData).length > 0) {
      // EDIT mode: Use rowData to build checkLockedbj
      const checkLockedbj = [{
        leid: rowData.LEID,
        me_code: rowData.ME_CODE || rowData.ME,
        cdr_number: rowData.CDR_NO || rowData.TAX_CODE,
        consol_group_key: rowData.CONSOL_GROUP_KEY,
        reporting_period: rowData.REPORTING_PERIOD,
        combination_key: rowData.COMBINATION_KEY,
        scenario_key: parseInt(filterParams.scenario || params.scenario)
      }];
      params.checkLockedbj = JSON.stringify(checkLockedbj);
    }

    // CRITICAL: Use application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
